import { green, red, yellow } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para tipos de resultado de julgamento.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const RESULTADO_JULGAMENTO = {
    SOBRESTADO:             { id: 'SOBRESTADO',             codigo: 'B', descricao: "Sobrestado",                        cor: red[900],    letra: '' },
    JULGADO_OBSERVACAO:     { id: 'JULGADO_OBSERVACAO',     codigo: 'O', descricao: "Julgado com observação",            cor: yellow[900], letra: 'O' },
    JULGADO_ALTERACAO_VOTO: { id: 'JULGADO_ALTERACAO_VOTO', codigo: 'T', descricao: "Julgado com alteração de voto",     cor: yellow[900], letra: 'A' },
    JULGADO:                { id: 'JULGADO',                codigo: 'S', descricao: "Julgado",                           cor: green[900],  letra: 'J' },
    NAO_JULGADO:            { id: 'NAO_JULGADO',            codigo: 'N', descricao: "Não julgado",                       cor: red[900],    letra: '' },
    CANCELADO:              { id: 'CANCELADO',              codigo: 'C', descricao: "Cancelado",                         cor: red[900],    letra: '' },
    ADIADO:                 { id: 'ADIADO',                 codigo: 'A', descricao: "Adiado",                            cor: red[900],    letra: '' },
    RETIRADO_DE_PAUTA:      { id: 'RETIRADO_DE_PAUTA',      codigo: 'R', descricao: "Retirado de Pauta",                 cor: red[900],    letra: '' },
    VISTA_REGIMENTAL:       { id: 'VISTA_REGIMENTAL',       codigo: 'V', descricao: "Vista Regimental",                  cor: red[900],    letra: '' },
    SUSPENSO:               { id: 'SUSPENSO',               codigo: 'P', descricao: "Suspenso",                          cor: red[900],    letra: '' },
    RESOLUCAO:              { id: 'RESOLUCAO',              codigo: 'J', descricao: "Resolução CSJT",                    cor: red[900],    letra: '' },
    CONVERTIDO_DILIGENCIA:  { id: 'CONVERTIDO_DILIGENCIA',  codigo: 'D', descricao: "Convertido em diligência",          cor: red[900],    letra: '' },
    ACOLHIDA_AFETACAO:      { id: 'ACOLHIDA_AFETACAO',      codigo: 'F', descricao: "Acolhida proposta de afetação",     cor: red[900],    letra: '' },
    NAO_ACOLHIDA_AFETACAO:  { id: 'NAO_ACOLHIDA_AFETACAO',  codigo: 'E', descricao: "Não acolhida proposta de afetação", cor: red[900],    letra: '' },
    EXCLUIDO_SESSAO:        { id: 'EXCLUIDO_SESSAO',        codigo: 'X', descricao: "Excluído da sessão de julgamento",  cor: red[900],    letra: '' }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de tipos de resultado de julgamento.
 * @readonly
 */
export default class ResultadoJulgamento {
    static situacaoBase = new SituacaoIdDescricaoBase(RESULTADO_JULGAMENTO);
    static MSG_ERRO_IDENTIFICACAO_RESULTADO_JULGAMENTO = 'Não foi possível identificar a situação do julgamento.';

    static getDescricao(id) {
        return ResultadoJulgamento.situacaoBase.getDescricao(id);
    }

    static getCor(id) {
        return ResultadoJulgamento.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getCorByCodigo(codigo) {
        let obj = ResultadoJulgamento.situacaoBase.getObjectByProperty('codigo', codigo);
        return obj ? ResultadoJulgamento.getCor(obj.id) : '#000000';
    }
}
